<div class="collage-filter-main" data-cy="collage-filter-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="collage-filter-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="collage-filter-header">
      <div class="section-header-title" data-cy="collage-filter-title">
        Collage Filters
      </div>
      <div style="flex: 1;"></div>
    </div>
    <app-tdo-progress-spinner style="flex: 1;" *ngIf="isLoading" data-cy="collage-filter-spinner"></app-tdo-progress-spinner>
    <!--  MAIN AREA-->
    <div *ngIf="!isLoading" class="section-content" style="flex: 1; display: flex; flex-direction: column; max-height: 100%; overflow-y: hidden;" data-cy="collage-filter-content">
      <div class="collage-filter-row" style="font-weight: 500;" data-cy="collage-filter-date-header">
        Date Range
      </div>
      <div class="collage-filter-row" data-cy="collage-filter-start-date-row">
        <div class="collage-filter-row-label" data-cy="collage-filter-start-date-label">
          From:
        </div>
        <div class="collage-filter-row-content" style="position: relative; top: -7px;" data-cy="collage-filter-start-date-content">
          <div style="display: flex; flex: 1;" data-cy="collage-filter-start-date-picker">
            <input style="border-bottom: 1px solid rgba(0,0,0,0.25);" matInput (dateChange)="onStartDateChange($event)" [ngModel]="filterModel.startDate"
                   [min]="datePickerStart" [max]="datePickerEnd" [matDatepicker]="pickerStart"
                   class="date-picker-input" placeholder="Start Date" data-cy="collage-filter-start-date-input">
            <mat-datepicker-toggle matSuffix [for]="pickerStart" data-cy="collage-filter-start-date-toggle"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart data-cy="collage-filter-start-datepicker"></mat-datepicker>
          </div>
        </div>
      </div>
      <div class="collage-filter-row" data-cy="collage-filter-end-date-row">
        <div class="collage-filter-row-label" data-cy="collage-filter-end-date-label">
          To:
        </div>
        <div class="collage-filter-row-content" style="position: relative; top: -7px;" data-cy="collage-filter-end-date-content">
          <div style="display: flex; flex: 1;" data-cy="collage-filter-end-date-picker">
            <input style="border-bottom: 1px solid rgba(0,0,0,0.25);" matInput (dateChange)="onEndDateChange($event)" [(ngModel)]="filterModel.endDate" [min]="datePickerStart" [max]="datePickerEnd" class="date-picker-input" [matDatepicker]="pickerEnd" placeholder="End Date" data-cy="collage-filter-end-date-input">
            <mat-datepicker-toggle matSuffix [for]="pickerEnd" data-cy="collage-filter-end-date-toggle"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd data-cy="collage-filter-end-datepicker"></mat-datepicker>
          </div>
        </div>
      </div>
      <div style="margin-top: 4px;" class="collage-filter-row" data-cy="collage-filter-sort-row">
        <div class="collage-filter-row-label" data-cy="collage-filter-sort-label">Sort By Date:</div>
        <div class="collage-filter-row-content" style="display: flex; margin-left: 10px;" data-cy="collage-filter-sort-content">
          <mat-radio-group [(ngModel)]="filterModel.sortType" aria-label="Select sort type" data-cy="collage-filter-sort-group">
            <mat-radio-button value="Ascending" data-cy="collage-filter-sort-ascending">Ascending</mat-radio-button>
            <mat-radio-button style="margin-left: 12px;" value="Descending" data-cy="collage-filter-sort-descending">Descending</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="collage-filter-row" data-cy="collage-filter-description-row">
        <div class="collage-filter-row-label" data-cy="collage-filter-description-label">Description:</div>
        <div class="collage-filter-row-content" data-cy="collage-filter-description-content">
          <input [(ngModel)]="filterModel.description" style="width: 96%; outline: unset; padding: 2px 6px 2px 6px; border-radius: var(--border-radius); background-color: var(--tdo-background); border: 1px solid rgba(0,0,0,0.05);" data-cy="collage-filter-description-input" />
        </div>
      </div>
      <div class="collage-filter-row" data-cy="collage-filter-fetch-row">
        <div class="collage-filter-row-label" style="margin-top: 20px;" data-cy="collage-filter-fetch-label">Fetch:</div>
        <div class="collage-filter-row-content" style="max-width: 250px;" data-cy="collage-filter-fetch-content">
          <app-tdo-dropdown [dataSource]="fetchModels" [value]="getFetchModel()" [isObjectValue]="true" dataSourceDisplayKey="label" (selectionChange)="onFetchChange($event)" data-cy="collage-filter-fetch-dropdown"></app-tdo-dropdown>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; min-height: 60px; padding-top: 6px;" data-cy="collage-filter-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="collage-filter-ok-button">Ok</button>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="collage-filter-cancel-button">Cancel</button>
    </div>
  </div>
</div>
